
import TimeUnit from "./TimeUnit.js";
import ZonedClock from "./ZonedClock.js";
import StringUtils from "@/utils/StringUtils.js";
import DateUtils from "@/utils/DateUtils.js";
import RcMonth from "./RcMonth.js";
import RcDay from "./RcDay.js";

/** A year, mirroring com.readychek.time.RcYear. */
export default class RcYear extends TimeUnit {

  constructor(date, timeZone) {
    super(date, timeZone);
  }

  value() {
    return this.yearValue();
  }

  name() {
    return StringUtils.toString(this.value());
  }

  day() {
    return new RcDay(this.internalDate(), this.timeZone());
  }

  month() {
    return new RcMonth(this.internalDate(), this.timeZone());
  }

  /** January of this year. */
  start() {
    return new RcMonth(
      ZonedClock.withFields(this.internalDate(), this.timeZone(), { month: DateUtils.JANUARY, day: 1 }),
      this.timeZone(),
    );
  }

  /** December of this year. */
  end() {
    return new RcMonth(
      ZonedClock.withFields(this.internalDate(), this.timeZone(), { month: DateUtils.DECEMBER, day: 1 }),
      this.timeZone(),
    );
  }

  firstMonth() {
    return this.start();
  }

  lastMonth() {
    return this.end();
  }

  next() {
    return this.shift(1);
  }

  previous() {
    return this.shift(-1);
  }

  yearsAgo(number) {
    return this.shift(-number);
  }

  /** Whether this year has a 29th of February. */
  isLeap() {
    return ZonedClock.daysInMonth(this.value(), DateUtils.FEBRUARY) === 29;
  }

  days() {
    return this.isLeap() ? 366 : 365;
  }

  /** The middle of the year, matching the java half(). */
  half() {
    return new RcYear(
      ZonedClock.withFields(this.internalDate(), this.timeZone(),
        { month: DateUtils.JUNE, day: 30 }),
      this.timeZone(),
    );
  }

  shift(years) {
    const parts = this.parts();
    const year = parts.year + years;
    const day = Math.min(parts.day, ZonedClock.daysInMonth(year, parts.month));
    return new RcYear(
      ZonedClock.withFields(this.internalDate(), this.timeZone(), { year, day }),
      this.timeZone(),
    );
  }
}
